var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00368E",
    d: "M12.543 0C17.766 0 22 4.253 22 9.5c0 1.461-.328 2.845-.915 4.082l.865 3.865c.241 1.075-.434 1.75-1.506 1.506l-3.84-.87c-.948.452-1.982.752-3.071.866-1.366 1.845-3.56 3.04-6.033 3.04-1.268 0-2.462-.313-3.509-.868l-2.55.789c-1.058.327-1.654-.265-1.332-1.325l.777-2.552C.321 16.979 0 15.774 0 14.495c0-2.519 1.243-4.748 3.15-6.107C3.698 3.666 7.695 0 12.543 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.37 15.979l3.386.78-.765-3.413.297-.625c.473-.996.721-2.089.721-3.221 0-4.142-3.343-7.5-7.466-7.5-3.36 0-6.201 2.23-7.138 5.296C6.07 7.103 6.773 7 7.5 7c4.142 0 7.5 3.356 7.5 7.495 0 .764-.114 1.501-.327 2.196.368-.11 1.697-.712 1.697-.712z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.043 17.828l-.513 1.658 1.66-.513.742.392C5.716 19.78 6.59 20 7.5 20c3.036 0 5.5-2.46 5.5-5.5S10.536 9 7.5 9 2 11.46 2 14.5c0 .922.225 1.807.65 2.598l.393.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA0000",
    d: "M7.5 15.5c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zM10.5 15.5c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zM4.5 15.5c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportActive);
export default __webpack_public_path__ + "static/media/support_active.6a80db60db698b5b7fc26a5f0eb29731.svg";
export { ForwardRef as ReactComponent };